import api from "./apiURL";
export async function getUserDetails(timePeriod = "alltime") {
  try {
    const response = await api.get(`/api/v1/user/userAcquisitions`, {
      params: { timePeriod },
    });
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
